exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".v-spinner .v-bounce2{animation:v-bounceStretchDelay 2s 1s infinite ease-in-out;animation-fill-mode:both}.v-spinner .v-bounce3{animation:v-bounceStretchDelay 2s 0s infinite ease-in-out;animation-fill-mode:both}@keyframes v-bounceStretchDelay{0%,to{transform:scale(0)}50%{transform:scale(1)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0cb69d1c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue-spinner/src/BounceLoader.vue
// module id = 143
// module chunks = 0